import { createAuthStore } from "@/stores/createAuthStore";
import {
  signInApi,
  refreshApi,
  signOutApi,
  type PatientUser,
  type AuthResponse,
} from "@/portals/patient/api/patientAuthApi";

export function toSession(data: AuthResponse) {
  // No expiry field is sent today (see AuthResponse) — NaN makes createAuthStore
  // read the lifetime off the access token's own `exp` claim instead.
  return { accessToken: data.accessToken, expiresIn: data.expiresIn ?? NaN, user: data.patient };
}

export const usePatientAuthStore = createAuthStore<PatientUser, [email: string, password: string]>({
  portal: "patient",

  signIn: async (email, password) => {
    const { data, error, code, retryAfterSeconds, otpExpiresInSeconds } = await signInApi(email, password);
    if (!data) return { data: null, error, code, retryAfterSeconds, otpExpiresInSeconds };
    return { data: toSession(data), error: null };
  },

  refresh: async () => {
    const { data, error, code } = await refreshApi();
    if (!data) return { data: null, error, code };
    return { data: toSession(data), error: null };
  },

  signOut: () => signOutApi().then(() => {}),
});
